import { Component, OnChanges, SimpleChanges } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { GetProductDetailQuery } from '../../common/gql/graphql';
import { BaseVariantSelectorComponent } from '../base-variant-selector/base-variant-selector.component';
import { FormatPricePipe } from '../../../shared/pipes/format-price.pipe';
import { TabbedDescriptionComponent } from '../tabbed-description/tabbed-description.component';
import { OfferLabelComponent } from '../offer-label/offer-label.component';
import { AddToWishlistButtonComponent } from '../add-to-wishlist-button/add-to-wishlist-button.component';
import { SelectedVariantControlsComponent } from '../selected-variant-controls/selected-variant-controls.component';
import { ShippingInfoLabelComponent } from '../../../shared/components/shipping-info-label/shipping-info-label.component';
import { DropdownContentDirective } from '../../../shared/components/dropdown/dropdown-content.directive';
import { InCartLabelComponent } from '../../../shared/components/in-cart-label/in-cart-label.component';
import { StockLevelLabelComponent } from '../stock-level-label/stock-level-label.component';
import { DropdownTriggerDirective } from '../../../shared/components/dropdown/dropdown-trigger.directive';
import { DropdownComponent } from '../../../shared/components/dropdown/dropdown.component';
import { StickyAnchorDirective } from '../../../shared/directives/sticky-anchor/sticky-anchor.directive';
import { StarRatingComponent } from '../../../shared/components/star-rating/star-rating.component';
import { BrandLabelComponent } from '../brand-label/brand-label.component';
import { AssetGalleryComponent } from '../asset-gallery/asset-gallery.component';
import { StickyAnchorContainerDirective } from '../../../shared/directives/sticky-anchor/sticky-anchor-container.directive';

type Variant = NonNullable<GetProductDetailQuery['product']>['variants'][number];

@Component({
    selector: 'kb-product-page-select-menu',
    templateUrl: './product-page-select-menu.component.html',
    styleUrls: ['./product-page-select-menu.component.scss'],
    standalone: true,
    imports: [
        StickyAnchorContainerDirective,
        AssetGalleryComponent,
        BrandLabelComponent,
        StarRatingComponent,
        StickyAnchorDirective,
        DropdownComponent,
        DropdownTriggerDirective,
        NgIf,
        NgFor,
        StockLevelLabelComponent,
        InCartLabelComponent,
        FontAwesomeModule,
        DropdownContentDirective,
        NgClass,
        ShippingInfoLabelComponent,
        SelectedVariantControlsComponent,
        AddToWishlistButtonComponent,
        OfferLabelComponent,
        TabbedDescriptionComponent,
        AsyncPipe,
        FormatPricePipe,
    ],
})
export class ProductPageSelectMenuComponent extends BaseVariantSelectorComponent implements OnChanges {
    selectedVariant: Variant | undefined;
    qty = 1;
    selectText = 'Select...';
    chevronDown = faChevronDown;

    override ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        const optionGroupNames = this.product?.optionGroups.map((og) => og.name).join(', ') ?? [];
        this.selectText = `Select ${optionGroupNames}...`;
    }
}
